import React from "react"

interface StatsViewModeSelectorProps {
  viewMode: "daily" | "weekly" | "monthly"
  onViewModeChange: (mode: "daily" | "weekly" | "monthly") => void
}

const StatsViewModeSelector: React.FC<StatsViewModeSelectorProps> = ({
  viewMode,
  onViewModeChange,
}) => {
  const getViewModeDescription = (mode: "daily" | "weekly" | "monthly") => {
    switch (mode) {
      case "daily":
        return "Günlük detaylı istatistikler"
      case "weekly":
        return "Haftalık özet istatistikler"
      case "monthly":
        return "Aylık özet istatistikler"
      default:
        return ""
    }
  }

  return (
    <div className="flex items-center justify-between bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
      <div className="flex items-center space-x-3">
        <span className="text-gray-700 font-medium">📊 Görünüm Modu:</span>
        <div className="flex items-center space-x-2 bg-gray-100 rounded-lg px-3 py-2">
          <span className="text-sm">👁️</span>
          <select
            className="bg-transparent text-gray-700 border-none outline-none text-sm font-medium"
            value={viewMode}
            onChange={(e) => onViewModeChange(e.target.value as "daily" | "weekly" | "monthly")}
          >
            <option value="daily" className="text-gray-800">
              Günlük Görünüm
            </option>
            <option value="weekly" className="text-gray-800">
              Haftalık Görünüm
            </option>
            <option value="monthly" className="text-gray-800">
              Aylık Görünüm
            </option>
          </select>
        </div>
      </div>
      <div className="text-sm text-gray-500">{getViewModeDescription(viewMode)}</div>
    </div>
  )
}

export default StatsViewModeSelector
